<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="650px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="isReadyToPrint || isAdmin && action == 'show'">
                        Towar - <strong>{{ shippingLabelGood.goodName }}</strong>
                    </template>
                    <template v-else>
                        Edycja towaru
                    </template>
                </h1>
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="shippingLabelGood.goodName"
                            label="Produkt"
                            outlined
                            dense
                            :disabled="isReadyToPrint && !isAdmin"
                            :error-messages="shippingLabelGoodNameErrors"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="shippingLabelGood.code"
                            label="Kod Towaru"
                            outlined
                            dense
                            :disabled="isReadyToPrint && !isAdmin"
                            :error-messages="shippingLabelGoodCodeErrors"
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="shippingLabelGood.availableAmount"
                            label="Do wysyłki"
                            outlined
                            dense
                            :disabled="isReadyToPrint && !isAdmin"
                            :error-messages="shippingLabelGoodAvailableAmountErrors"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    v-if="!isReadyToPrint || isAdmin && action !== 'show'"
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, integer, maxLength, minValue } from 'vuelidate/lib/validators'
import { hasUserPermission } from '@/utils/permissionsHandler'

export default {
    name: 'ShippingLabelGoodDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        shippingLabelGoodData: {
            type: Object,
            default: () => {}
        },
        isReadyToPrint: {
            type: Boolean
        },
        actionLoading: {
            type: Boolean
        },
        goods: {
            type: Array,
            default: () => []
        },
        action: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            shippingLabelGood: {
                goodName: null,
                code: null,
                availableAmount: null
            },
        }
    },
    validations() {
        return {
            shippingLabelGood: {
                goodName: {
                    required,
                    isUnique: value => {
                        const trimmedValue = value?.trimStart().trimEnd()

                        if (trimmedValue !== this.savedProductName && this.goods.some(item => item.goodName === trimmedValue)) {
                            return false
                        }

                        return true
                    }
                },
                code: {
                    integer,
                    maxLength: maxLength(30)
                },
                availableAmount: {
                    required,
                    integer,
                    minValue: minValue(1)
                },
            },
        }
    },
    computed: {
        isAdmin() {
            return hasUserPermission('shipping_labels_admin_update')
        },
        // Walidacje
        shippingLabelGoodNameErrors() {
            const errors = []

            if (!this.$v.shippingLabelGood.goodName.$dirty) return errors
            !this.$v.shippingLabelGood.goodName.required && errors.push('Proszę podać nazwę produktu.')

            !this.$v.shippingLabelGood.goodName.isUnique && errors.push('Wybrany produkt istnieje już w tej zawieszce.')

            return errors
        },
        shippingLabelGoodCodeErrors() {
            const errors = []

            if (!this.$v.shippingLabelGood.code.$dirty) return errors

            if (!this.$v.shippingLabelGood.code.integer) {
                errors.push('Niepoprawny format.')
            }
            if (!this.$v.shippingLabelGood.code.maxLength) {
                errors.push('Pole może zawierać maksymalnie 30 cyfr.')
            }

            return errors
        },
        shippingLabelGoodAvailableAmountErrors() {
            const errors = []

            if (!this.$v.shippingLabelGood.availableAmount.$dirty) return errors

            if (!this.$v.shippingLabelGood.availableAmount.required || !this.$v.shippingLabelGood.availableAmount.minValue) {
                errors.push('Proszę podać ilość.')
            }

            if (!this.$v.shippingLabelGood.availableAmount.integer) {
                errors.push('Niepoprawny format.')
            }

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.shippingLabelGood = JSON.parse(JSON.stringify(this.shippingLabelGoodData))
                this.savedProductName = this.shippingLabelGood.goodName
            } else {
                setTimeout(() => {
                    this.$v.$reset()
                    this.filteredPackageTypes = []
                    this.shippingLabelGood = {
                        goodName: null,
                        code: null,
                        availableAmount: null
                    }
                }, 500)
            }
        }
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }
            let payload = JSON.parse(JSON.stringify(this.shippingLabelGood))

            this.$emit('on-save', payload)
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>